
const backendURL = process.env.REACT_APP_EDI_SUBSCRIPTION_BACKEND_BASE_URL;

const CONSTANTS = {
        UI_BACKEND_BASE_URL: backendURL
}

Object.freeze(CONSTANTS);

export default CONSTANTS;